window.onload = () => {
    // get all a tags with /request-a-demo/ or #demo-form in the href with or without the trailing slash
    const radModalLinks = document.querySelectorAll(
        'a[href*="/request-a-demo"],a[href*="#demo-form"],a[href*="#book-demo"]'
    );

    radModalLinks.forEach((link) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            window.dispatchEvent(new CustomEvent("radmodalopen"));
            window.dispatchEvent(new CustomEvent("pegasus-rad-open"));
        });
    });
};

document.addEventListener("alpine:init", () => {
    Alpine.data("radModal", () => ({
        open: false,
        init() {},
        closeRad() {
            this.open = false;
            window.dispatchEvent(new CustomEvent("pegasus-rad-close"));
        },
    }));
});
